import React from 'react';
import Header from '../Components/Header';
import AppStore from '../Components/assets/appstore';
import Footer from '../Components/Footer';
import { withMedia } from 'react-media-query-hoc';
import phone from '../assets/Phone.svg';
import './Home.css';

function Home (props) {
  const media = props.media;

  return (
    <main className="home header-offset">
      <Header wide noShadow/>
      <section className="splash">
        <div className="splash-container wide-container">
          <div className="splash-text">
            <h1>Your support directory</h1>
            <p>Find support lines, online chats, therapists, and counsellers simply by answering a few quick questions. 100% private, we don’t ask for any personal information and we don’t store anything.</p>
            <a href="https://itunes.apple.com/app/id1448168158">
              <span className="sr-only">Download on the App Store</span>
              <AppStore/>
            </a>
          </div>
          {media.mobile
            ? null
            : <div className="splash-image">
                <img src={phone} alt="Find Help Example"/>
              </div>
          }
        </div>
      </section>
      <Footer container="wide-container"/>
    </main>
  );
}

export default withMedia(Home);



// WEBPACK FOOTER //
// ./src/Pages/Home.js